//
export default [
    {
        text: 'rut',
        value: ({ hr_employee }) => {
            return hr_employee.rut
        },
        format: 'rut',
    },
    {
        text: 'nombre',
        value: ({ hr_employee }) => {
            return (
                hr_employee.names +
                ' ' +
                hr_employee.last_name1 +
                ' ' +
                hr_employee.last_name2
            )
        },
    },
    {
        text: 'periodo',
        value: ({period_year,period_month}) =>{
            return (
                period_month + 
                '/' +
                period_year 
            )
        },
    },
    {
        text: 'haberes',
        value: 'total_haberes',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'descuentos',
        value: 'amount_discount_hh',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'líquido',
        value: 'liquid_salary',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'ccaf empresa',
        value: 'ccaf',
        align: 'right',
        format: 'currency',
    },
    {
        text: 'mutual',
        value: 'mutual_amount',
        align: 'right',
        format: 'currency',
    },
]
